import { render } from "./AdvancedTraining.vue?vue&type=template&id=4c64e18a"
import script from "./AdvancedTraining.vue?vue&type=script&lang=js"
export * from "./AdvancedTraining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__